import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../BackendConnections";
import HexaImage from "../utils/imgCards/HexaImage";
import Network from "./Network";
import {
  fetchConnectionsAction,
  fetchProfileConnectionsAction,
} from "../../redux/actions/network/networkAction";
import Slider from "react-slick";
import { BiEdit } from "react-icons/bi";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { IconContext } from "react-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const MyConnections = (props) => {
  console.log(props?.profileConnections);
  const [myConnectionMore, setMyConnectionMore] = useState(false);

  const [data, setData] = useState({
    is_connections: false,
    is_profile_connections: false,
  });

  const NextArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-down slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-down-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };

  const PrevArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-up slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-up-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      if (props.connections.length === 0 && data.is_connections === false) {
        setData((prevState) => ({ ...prevState, is_connections: true }));
        props.fetchConnections(props.profile.id);
      }

      if (
        props.profileConnections.length === 0 &&
        data.is_profile_connections === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_profile_connections: true,
        }));
        props.fetchProfileConnections(props.profile.id);
      }
    }
  }, [props]);

  const settings = {
    infinite: true,
    dots: false,
    vertical: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    slidesPerRow: 2,
    swipeToSlide: true,
    verticalSwiping: true,
    nextArrow: (
      <div onClick>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            // paddingTop: "5px",
          }}
        >
          <MdOutlineKeyboardArrowDown
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
    prevArrow: (
      <div className="row" onClick>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            float: "right", // Float it to the right as specified
            // paddingTop:'4px'
          }}
        >
          <MdOutlineKeyboardArrowUp
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
  };

  return (
    <Network>
      <div className="row connection-request-section">
        <div className="col-12">
          <h2 className="block-title"> Connections</h2>
          <div className="border-box">
            <div className="row small-gutter">
              <div className="col-12">
                <div className="border-box-title">
                <label>
  <label className="MY" style={{ fontWeight: 100 }}>MY</label> Connections
</label>
                  {/* {props.connections.length > 2 ?
                                        <Link to="" className="more-btn" onClick={() => setMyConnectionMore(!myConnectionMore)}>
                                            more
                                        </Link>
                                        : ''} */}
                </div>
              </div>
              {props.connections.length > 6 ? (
                <Slider {...settings}>
                  {props.connections.map((row, index) => {
                    return (
                      <div
                        className="col-sm-6 col-12 cmb-12"
                        key={row.id}
                        style
                      >
                        <div className="connect-profile">
                          <div className="profile-thumb">
                            <div className="hexagon-wrap">
                              <HexaImage
                                image={
                                  row.profile_pic != null
                                    ? IMAGEAPI + row.profile_pic
                                    : "/assets/images/no-profile.png"
                                }
                              />
                            </div>
                          </div>

                          <div className="profile-content">
                            <div className="left-content">
                              <Link to={`/user/contact/${row.id}/`}>
                                <div className="name">
                                  {row.userId.username}
                                </div>
                              </Link>{" "}
                              <div className="designition">
                                {row.primary_job_title +
                                  " - " +
                                  row.company_name}
                              </div>
                              <div className="mutual-connection">
                                {row.mutual_connections} mutual connections
                              </div>
                            </div>
                            <div className="right-content"></div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              ) : (
                props.connections.map((row, index) => {
                  return (
                    <div className="col-sm-6 col-12 cmb-12" key={row.id}>
                      <div className="connect-profile">
                        <div className="profile-thumb">
                          <div className="hexagon-wrap">
                            <HexaImage
                              image={
                                row.profile_pic != null
                                  ? IMAGEAPI + row.profile_pic
                                  : "/assets/images/no-profile.png"
                              }
                            />
                          </div>
                        </div>
                        <div className="profile-content">
                          <div className="left-content">
                            <Link to={`/user/contact/${row.id}/`}>
                              <div className="name">{row.userId.username}</div>
                            </Link>{" "}
                            <div className="designition">
                              {row.primary_job_title + " - " + row.company_name}
                            </div>
                            <div className="mutual-connection">
                              {row.mutual_connections} mutual connections
                            </div>
                          </div>
                          <div className="right-content"></div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
              <div className="col-12 mt-4">
                <div className="border-box-title">
                  <label>Profile Connections</label>
                  {/* <Link to="" className="more-btn">
                                        more
                                    </Link> */}
                </div>
              </div>

              {props.profileConnections.length > 6 ? (
                <Slider {...settings}>
                {props.profileConnections.map((row, index) => {
                  return (
                    <div className="col-sm-6 col-12 cmb-12" key={row.id}>
                      <div className="connect-profile">
                        <div className="profile-thumb">
                          <div className="hexagon-wrap">
                            <HexaImage
                              image={
                                row.profile_pic != null
                                  ? IMAGEAPI + row.profile_pic
                                  : "/assets/images/no-profile.png"
                              }
                            />
                          </div>
                        </div>
                        <div className="profile-content">
                          <div className="left-content">
                            <Link to={`/user/contact/${row.id}/`}>
                              <div className="name">{row.userId.username}</div>
                            </Link>{" "}
                            <div className="designition">
                              {row.primary_job_title + " - " + row.company_name}
                            </div>
                            <div className="mutual-connection">
                              {row.mutual_connections} mutual connections
                            </div>
                          </div>
                          <div className="right-content"></div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                  </Slider>
              ) :
              props.profileConnections.length < 7 ? (
                props.profileConnections.map((row, index) => {
                  return (
                    <div className="col-sm-6 col-12 cmb-12" key={row.id}>
                      <div className="connect-profile">
                        <div className="profile-thumb">
                          <div className="hexagon-wrap">
                            <HexaImage
                              image={
                                row.profile_pic != null
                                  ? IMAGEAPI + row.profile_pic
                                  : "/assets/images/no-profile.png"
                              }
                            />
                          </div>
                        </div>
                        <div className="profile-content">
                          <div className="left-content">
                            <Link to={`/user/contact/${row.id}/`}>
                              <div className="name">{row.userId.username}</div>
                            </Link>{" "}
                            <div className="designition">
                              {row.primary_job_title + " - " + row.company_name}
                            </div>
                            <div className="mutual-connection">
                              {row.mutual_connections} mutual connections
                            </div>
                          </div>
                          <div className="right-content"></div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) :
              (
                <div className="col-12">
                  <p style={{ textAlign: "left", fontWeight: 600 }}>
                    You have no profile connections.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Network>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const connections = state.network.connections;
  const is_connections = state.network.is_connections;
  const profileConnections = state.network.profileConnections;
  const is_profile_connections = state.network.is_profile_connections;

  return {
    user: user,
    profile: profile,
    connections: connections,
    is_connections: is_connections,
    profileConnections: profileConnections,
    is_profile_connections: is_profile_connections,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchConnections: (profileId) =>
      dispatch(fetchConnectionsAction(profileId)),
    fetchProfileConnections: (profileId) =>
      dispatch(fetchProfileConnectionsAction(profileId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyConnections);
